var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.133 0 0 3.133 0 7s3.133 7 7 7 7-3.133 7-7-3.133-7-7-7zm6.097 7A6.097 6.097 0 11.903 7a6.097 6.097 0 1112.194 0zM8.894 9.492L6.602 7.827a.34.34 0 01-.138-.274V3.048a.34.34 0 01.338-.338h.396a.34.34 0 01.338.338v4.13l1.99 1.448c.153.11.184.322.074.474l-.232.319a.341.341 0 01-.474.073z",
    fill: "#0B0B0B"
  })));
}

export default SvgClock;